import { PaymentParameters } from '@mews-commander/data-access';
import { AsyncAction, CommanderThunkAction, CommanderThunkDispatch } from '@mews-commander/types';
import { createFetchAction, notEmpty } from '@mews-commander/utils';
import { setProfiles } from '../ducks';
import { setBills } from '../ducks/bills';
import { setCurrentEnterpriseCashiers } from '../ducks/cashiers';
import { setPaymentCards } from '../ducks/paymentCards';
import { setPayments } from '../ducks/payments';
import { PAYMENTS_FETCH } from './constants';

type Params = Pick<PaymentParameters, 'accountId' | 'extent' | 'ids'>;

const fetch =
    ({ accountId, ids, extent }: Params): CommanderThunkAction<AsyncAction> =>
    async (dispatch, _getState, { repositories }) => {
        const promise = repositories.payments
            .getAll({ accountId, ids, extent })
            .then(({ bills, cashiers, paymentCards, profiles, payments }) => {
                if (notEmpty(paymentCards)) {
                    // @ts-expect-error Argument of type 'CreditCard[] | null | undefined' is not assignable to parameter of type 'PaymentCard[]'.
                    dispatch(setPaymentCards(paymentCards));
                }

                if (notEmpty(bills)) {
                    // @ts-expect-error Argument of type 'Bill[] | null | undefined' is not assignable to parameter of type 'Bill[]'
                    dispatch(setBills(bills));
                }
                if (notEmpty(cashiers)) {
                    // @ts-expect-error Argument of type 'Cashier[] | null | undefined' is not assignable to parameter of type 'Cashier[]'.
                    dispatch(setCurrentEnterpriseCashiers(cashiers));
                }

                if (notEmpty(profiles)) {
                    // @ts-expect-error Argument of type 'Profile[] | null | undefined' is not assignable to parameter of type 'Profile[]'
                    setProfiles(profiles);
                }

                if (notEmpty(payments)) {
                    // @ts-expect-error Argument of type Payment[] is not assignable to parameter of type Payment[]
                    dispatch(setPayments(payments));
                }
            });

        return dispatch(createFetchAction(PAYMENTS_FETCH, promise));
    };

export const fetchPaymentsByIds =
    ({ accountId, ids, extent }: Params) =>
    async (dispatch: CommanderThunkDispatch) =>
        dispatch(fetch({ accountId, ids, extent }));
